import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formateDate } from "../../components/helpers/formateDate";
import SureModal from "../../components/Modals/SureModal";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { Switch } from "antd";
import { versionAction } from "../../store/Slices/VersionsSlice";
import TableTitle from "../Accounts/Helpers/TableTitle";
import AddEditVersionModal from "./Modals/AddEditVersionModal";
import params from "../Params/Params";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Versions = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);
    const { versions, isLoading } = useSelector((state) => state.VersionsSlice);

    const rows = versions?.data?.value?.rows.map((element) => {
        return {
            ...element,
            dateCreate: element.dateCreate
                ? formateDate(element.dateCreate)
                : "",
            isRequired: (
                <Switch
                    disabled={
                        !mnemo?.children[0]?.children?.find(
                            (el) => el.mnemo === "updateBtn"
                        )
                    }
                    value={element.isRequired}
                    onChange={() => {
                        dispatch(
                            versionAction({
                                flag: "post",
                                value: {
                                    id: element.id,
                                    iosCode: element.iosCode,
                                    androidCode: element.androidCode,
                                    isRequired: !element.isRequired,
                                },
                            })
                        ).then(() => {
                            dispatch(versionAction({ flag: "get" }));
                        });
                    }}
                />
            ),
            isRequiredBool: element.isRequired,
        };
    });

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [versionInfo, setVersionInfo] = useState();
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });

    useEffect(() => {
        dispatch(versionAction({ flag: "get" }));
    }, []);

    const items = [
        {
            key: "2",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "updateBtn"
            ),
        },
        {
            key: "1",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "deleteBtn"
            ),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Версия" },
        {
            label: "По версии Android",
            value: 2,
            index: "androidCode",
            title: "Версия Android",
        },
        {
            label: "По версии IOS",
            value: 3,
            index: "iosCode",
            title: "Версия IOS",
        },
        {
            label: "По дате версии",
            value: 4,
            index: "dateCreate",
            title: "Дата версии",
        },
        {
            label: "По обезтаельному",
            value: 5,
            index: "isRequired",
            title: "Обязательное",
        },
    ];

    const onClickDelete = () => {
        dispatch(
            versionAction({ flag: "delete", value: { id: versionInfo.id } })
        ).then(() => {
            dispatch(versionAction({ flag: "get" }));
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "amount") {
                        formattedItems["AmountFrom"] = values[index][0];
                        formattedItems["AmountTo"] = values[index][1];
                    } else if (key === "dateCreate") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            versionAction({
                flag: "get",
                value: {
                    isDeleted: filters.isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setVersionInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            versionAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            versionAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    const handleSwitchChange = (element) => {
        dispatch(
            versionAction({
                flag: "post",
                value: {
                    id: element.id,
                    iosCode: element.iosCode,
                    androidCode: element.androidCode,
                    isRequired: !element.isRequired,
                },
            })
        ).then(() => {
            dispatch(versionAction({ flag: "get" }));
        });
    };

    return (
        <>
            <AddEditVersionModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                versionInfo={versionInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={isLoading}
                    onClickRowOne={(record) => {
                        setVersionInfo({
                            ...record,
                            isRequired: record.isRequiredBool,
                        });
                    }}
                    columns={versions}
                    rows={rows}
                    total={versions?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children[0]?.children.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    searchble={false}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={versions}
                    elementsListLoading={isLoading}
                    setIsOpenAddEditModal={isOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    mnemo={mnemo}
                    handleSwitchChange={handleSwitchChange}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Versions;
